module.exports = __webpack_public_path__ + "img/ball_1.c5ffc7b4.svg";